<template>
  <div>
    <div class="bg-menulist">
      <div
        class="menu-list"
        v-for="list of MenuList"
        :key="list.id"
        @click="checkMenuType(list)"
        :style="`--bg-color:${list.bg_color || 'white'}`"
      >
        <v-row class="align-items-center">
          <v-col cols="3" class="text-center">
            <span class="px-3">
              <template v-if="list.path == 'reward-transaction'">
                <div class="position-reletive d-inline">
                  <div class="random-reward" style="top: 10%">
                    <font-awesome-icon :icon="['fas', 'gift']" class="ft-16" />
                  </div>
                  <div class="random-reward" style="top: 2%">
                    <font-awesome-icon
                      :icon="['fas', 'expand']"
                      class="expand"
                    />
                  </div>
                </div>
              </template>
              <template v-else>
                <font-awesome-icon :icon="['fas', list.icon]" class="ft-20" />
              </template>
            </span>
          </v-col>
          <v-col class="p-0" cols="5">
            <span>{{ list.customer_menu_language[0]?.name || list.name }}</span>
          </v-col>
          <v-col cols="2" class="text-center">
            <v-badge
              color="error"
              pill
              inline
              :content="
                list.path == 'privilege'
                  ? profile.total_coupon_can_use
                  : profile.total_random_reward
              "
              class="px-2 mb-1"
              v-show="
                (profile.total_random_reward &&
                  list.path == 'reward-transaction') ||
                (profile.total_coupon_can_use && list.path == 'privilege')
              "
            >
            </v-badge>
          </v-col>
          <v-col cols="2">
            <font-awesome-icon
              :icon="['fas', 'chevron-right']"
              class="icon-color"
            />
          </v-col>
        </v-row>
      </div>
      <!-- 
      <div class="menu-list" v-for="list of customLink" :key="list.id">
        <v-row class="align-items-center" @click="openLink(list.url)">
          <v-col
            cols="3"
            class="d-flex align-items-center justify-content-center"
          >
            <c-img :src="list.url" class="custom-link-image"></c-img>
          </v-col>
          <v-col class="p-0" cols="5">
            <span>{{ list.name }}</span>
          </v-col>
          <v-col cols="2" class="text-center"> </v-col>
          <v-col cols="2">
            <font-awesome-icon
              :icon="['fas', 'chevron-right']"
              class="icon-color"
            />
          </v-col>
        </v-row>
      </div> -->
    </div>

    <ModalLoading ref="modalLoading" />
  </div>
</template>

<script>
import ModalLoading from "@/components/other/ModalLoading.vue";
import CodeVerificationDialogContent from "@/components/dialog-content/CodeVerificationDialogContent.vue";
import { useDialog } from "@/services/dialogService";
function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}
export default {
  components: {
    ModalLoading
  },
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  props: ["MenuList", "profile"],
  data() {
    return {
      modalShow: false,
      customLink: []
    };
  },
  created() {},
  methods: {
    checkMenuType(item) {
      [
        {
          id: 9,
          customer_menu_type_id: 3,
          name: "ดูบาร์โค้ดสมาชิก",
          icon: "barcode",
          path: "google.com",
          bg_color: "",
          sort_order: 0,
          display: 1,
          customer_menu_language: [
            {
              id: 73,
              language_id: 1,
              customer_menu_id: 9,
              name: "ดูบาร์โค้ดสมาชิก"
            }
          ]
        },
        {
          id: 1,
          customer_menu_type_id: 1,
          name: "สิทธิพิเศษ",
          icon: "ticket-alt",
          path: "privilege",
          bg_color: "",
          sort_order: 1,
          display: 1,
          customer_menu_language: [
            {
              id: 1,
              language_id: 1,
              customer_menu_id: 1,
              name: "สิทธิพิเศษ"
            }
          ]
        },
        {
          id: 2,
          customer_menu_type_id: 1,
          name: "ของขวัญ",
          icon: "gift",
          path: "reward",
          bg_color: "",
          sort_order: 2,
          display: 1,
          customer_menu_language: [
            {
              id: 6,
              language_id: 1,
              customer_menu_id: 2,
              name: "ของขวัญ"
            }
          ]
        },
        {
          id: 3,
          customer_menu_type_id: 1,
          name: "ข่าวสาร",
          icon: "newspaper",
          path: "news",
          bg_color: "",
          sort_order: 3,
          display: 1,
          customer_menu_language: [
            {
              id: 8,
              language_id: 1,
              customer_menu_id: 3,
              name: "ข่าวสาร"
            }
          ]
        },
        {
          id: 4,
          customer_menu_type_id: 1,
          name: "สแตมป์การ์ด",
          icon: "star",
          path: "stampcard",
          bg_color: "",
          sort_order: 4,
          display: 1,
          customer_menu_language: [
            {
              id: 10,
              language_id: 1,
              customer_menu_id: 4,
              name: "สแตมป์การ์ด"
            }
          ]
        },
        {
          id: 5,
          customer_menu_type_id: 1,
          name: "ประวัติการจอง",
          icon: "calendar-check",
          path: "booking",
          bg_color: "",
          sort_order: 5,
          display: 1,
          customer_menu_language: [
            {
              id: 12,
              language_id: 1,
              customer_menu_id: 5,
              name: "ประวัติการจอง"
            }
          ]
        },
        {
          id: 6,
          customer_menu_type_id: 1,
          name: "รางวัลแสกนลุ้นรับ",
          icon: "gift",
          path: "reward-transaction",
          bg_color: "",
          sort_order: 6,
          display: 1,
          customer_menu_language: [
            {
              id: 14,
              language_id: 1,
              customer_menu_id: 6,
              name: "รางวัลแสกนลุ้นรับ"
            }
          ]
        },
        {
          id: 7,
          customer_menu_type_id: 2,
          name: "ทดสอบ",
          icon: "calendar-check",
          path: "gm-lab-frontend.vercel.app",
          bg_color: "",
          sort_order: 7,
          display: 1,
          customer_menu_language: [
            {
              id: 16,
              language_id: 1,
              customer_menu_id: 7,
              name: "ทดสอบ"
            }
          ]
        },
        {
          id: 8,
          customer_menu_type_id: 3,
          name: "ติดต่อเจ้าหน้าที่",
          icon: "calendar-check",
          path: "gm-lab-frontend.vercel.app",
          bg_color: "",
          sort_order: 8,
          display: 1,
          customer_menu_language: [
            {
              id: 18,
              language_id: 1,
              customer_menu_id: 8,
              name: "ติดต่อเจ้าหน้าที่"
            }
          ]
        },
        {
          id: 10,
          customer_menu_type_id: 1,
          name: "ประวัติการซื้อ",
          icon: "calendar-check",
          path: "purchase-history",
          bg_color: "",
          sort_order: 9,
          display: 1,
          customer_menu_language: [
            {
              id: 75,
              language_id: 1,
              customer_menu_id: 10,
              name: "ประวัติการซื้อ"
            }
          ]
        },
        {
          id: 11,
          customer_menu_type_id: 4,
          name: "รหัสยืนยัน",
          icon: "camera",
          path: "",
          bg_color: "",
          sort_order: 10,
          display: 1,
          customer_menu_language: [
            {
              id: 77,
              language_id: 1,
              customer_menu_id: 11,
              name: "รหัสยืนยัน"
            }
          ]
        },
        {
          id: 12,
          customer_menu_type_id: 1,
          name: "สาขา",
          icon: "location-arrow",
          path: "location",
          bg_color: "",
          sort_order: 11,
          display: 1,
          customer_menu_language: [
            {
              id: 78,
              language_id: 1,
              customer_menu_id: 12,
              name: "Branch List Contact"
            }
          ]
        },
        {
          id: 13,
          customer_menu_type_id: 1,
          name: "FAQ",
          icon: "question",
          path: "frequently-asked-questions",
          bg_color: "",
          sort_order: 12,
          display: 1,
          customer_menu_language: [
            {
              id: 79,
              language_id: 1,
              customer_menu_id: 13,
              name: "คำถามพบบ่อย"
            }
          ]
        },
        {
          id: 14,
          customer_menu_type_id: 1,
          name: "Ticket",
          icon: "clipboard-list",
          path: "ticket",
          bg_color: "",
          sort_order: 13,
          display: 1,
          customer_menu_language: [
            {
              id: 80,
              language_id: 1,
              customer_menu_id: 14,
              name: "Ticket"
            }
          ]
        }
      ];
      if (item.id == 9) return this.emitter.emit("openProfileModal");
      if (item.customer_menu_type_id == 1 || item.customer_menu_type_id == 0) {
        if (item.id == 6 || item.id == 7) return this.$router.push(item.path);
        return this.$router.push(item.path + `?title=${item.name}`);
      } else if (item.customer_menu_type_id == 2) {
        let check = isValidHttpUrl(item.path);

        return !check
          ? window.open("https://" + item.path)
          : window.open(item.path);
      } else if (item.customer_menu_type_id == 4) {
        this.dialog.showCustom(CodeVerificationDialogContent, {
          refDocId: this.$store.state.shortProfile?.user_guid || "",
          docType: 2
        });
      }
    },
    async getCustomLink() {
      const res = await this.$axios("/api/v1/setting/customlink/list");
      this.customLink = res.detail.filter(el => el.status == 1);
    },
    openLink(url) {
      let check = isValidHttpUrl(url);

      return !check ? window.open("https://" + url) : window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-menulist {
  // background-color: #f1f1f1;
  .menu-list {
    &:first-of-type {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:last-of-type {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}

.bg-menulist .menu-list:not(:last-child) {
  border-bottom: 1px solid #e1e1e1;
}
.menu-list {
  background-color: var(--bg-color);
  padding: 20px 0;
}
.menu-list-bottom {
  padding: 20px 0;
}
.ft-20 {
  font-size: var(--font-title);
}
.icon-color {
  color: #c9c9c9;
}
.random-reward {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.expand {
  font-size: 30px;
}
.position-reletive {
  position: relative;
}
</style>
